import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'

import ACCESS from 'utils/Access'

import * as profileSelectors from 'app/modules/profile/selectors'
import * as selectors from 'app/modules/meetings/selectors'
import * as actions from 'app/modules/meetings/actions'

import MeetingTypeList from './component'

function makeMapStateToProps() {
  return state => ({
    profileUrl: profileSelectors.profileUrl(state),
    profileUrlHandle: profileSelectors.profileUrlHandle(state),
    defaultMeetingtype: selectors.getDefaultMeetingType(state),
    meetingTypes: selectors.getMeetingTypes(state),
    isMeetingTypesLoaded: selectors.isMeetingTypesLoaded(state),
    isDefaultSettingsLoaded: selectors.isMeetingSettingsLoaded(state),
    isOnPaidPlan: ACCESS.hasPaidGates(),
  })
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        fetchMeetingTypes: actions.fetchMeetingTypes,
        fetchMeetingSettings: actions.fetchMeetingSettings,
      },
      dispatch
    ),
  }
}

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchMeetingTypes()
      this.props.actions.fetchMeetingSettings()
    },
  }),
  withRouter
)(MeetingTypeList)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/MeetingTypesList/index.js